module.exports = __webpack_public_path__ + "img/defaultteam.ee79b046.png";